// extracted by mini-css-extract-plugin
export var numpadContainer = "_fb-1";
export var phoneButton = "_fb-0";